var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.membershipPackage)?_c('span',[(_vm.membershipPackage.type === 'package')?_c('span',{staticClass:"icon mr-1"},[_c('i',{staticClass:"mdi mdi-package-variant"})]):_c('span',{staticClass:"icon mr-1"},[_c('i',{staticClass:"mdi mdi-card-account-details-outline"})]),_c('span',[_vm._v(_vm._s(_vm.membershipPackage.name)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }